import React from 'react';

import { PersonalAccessTokensSection } from '../../authentication/components/PersonalAccessTokensSection';
import { Messages } from '../../codegen/Localize';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { UserSettingsHelper } from '../UserSettingsHelper';
import { ConnectedDevices } from './connected-clients/ConnectedClientsSection';
import { SavedCredentialsForDataSourceSetting } from './SavedCredentialsForDataSourceSetting';

export interface SecuritySettingsProps {
  //meta data realted to business logic
  serverUser: IServerUserInfo;
  isViewerSelf: boolean;
  isServerUserSubplace: boolean;
}

export function SecuritySettings(props: SecuritySettingsProps) {
  return (
    <>
    <h2 className={UserSettingsStyle.titleText}>{Messages.userSettings_Security_Header()}</h2>
    <table>
      <tbody>
        {props.isViewerSelf && !props.isServerUserSubplace && <tr>
          <td className={UserSettingsStyle.tbody} colSpan={3}>
            <SavedCredentialsForDataSourceSetting serverUser={props.serverUser} />
          </td>
        </tr>}
        {props.isViewerSelf && !props.isServerUserSubplace && UserSettingsHelper.getSectionDividerLine()}
        <tr>
          <td className={UserSettingsStyle.tbody} colSpan={3}>
            <ConnectedDevices serverUser={props.serverUser} />
          </td>
        </tr>
        {FeatureFlags.personalAccessTokensEnabled && UserSettingsHelper.getSectionDividerLine() }
        {FeatureFlags.personalAccessTokensEnabled && <tr>
          <td className={UserSettingsStyle.tbody} colSpan={3}>
            <PersonalAccessTokensSection canCreatePersonalAccessTokens={props.isViewerSelf} serverUser={props.serverUser}/>
          </td>
        </tr>}
        {UserSettingsHelper.getSectionDividerLine()}
      </tbody>
    </table>
    </>
  );
}
